module.exports = __webpack_public_path__ + "img/dedicated-claims-concierge.be4e3656.jpg";